<template>
  <div class="max_box" :style="'min-height:' + height + 'px;'">
    <div class="box_form">
      <div>
        <p style="color: #676767;margin-bottom: 5px;">订单号 :</p>
        <el-input style="width: 220px" v-model="form.orderNum" placeholder="请输入贵司订单号/科坦订单号"
                  size="mini" clearable></el-input>
      </div>
      <div class="time_box">
        <div>
          <p style="color: #676767;margin-bottom: 5px;">日期选择 :</p>
          <el-select v-model="form.dateType" placeholder="请选择" style="width: 110px;" size="mini">
            <el-option label="预订日期" :value="0"></el-option>
            <el-option label="入住日期" :value="1"></el-option>
            <el-option label="离店日期" :value="2"></el-option>
          </el-select>
        </div>

        <div>
          <p style="color: #676767;margin-bottom: 12px;"></p>
          <el-date-picker v-model="form.orderDates" type="daterange" range-separator="-"
                          start-placeholder="开始时间" end-placeholder="结束时间"
                          value-format="yyyy-MM-dd" size="mini"
                          style="position: relative;top: 2px;width: 230px !important;">
          </el-date-picker>
        </div>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">开票类型 :</p>
        <el-select v-model="form.invoiceType" placeholder="请选择" style="width: 110px;" size="mini" clearable>
          <el-option label="普票" :value="1"></el-option>
          <el-option label="专票" :value="2"></el-option>
        </el-select>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 15px;"></p>
        <b2b-button style="width: 60px;height: 28px;line-height: 28px;" @click="onSearch(true)">搜 索</b2b-button>
        <b2b-button style="width: 60px;height: 28px;line-height: 28px;margin-left: 10px" @click="toApplyInvoice"
                    :disabled="!orders.length || (!this.isCheckAll && !this.checkOrderIds.length && !this.excludeOrderIds.length)">
          开发票
        </b2b-button>
      </div>
    </div>

    <div
      style="height: 30px;line-height: 30px;background-color: #e6f7ff;border: 1px solid #a0dbff;padding: 0 8px;border-radius: 4px">
      已选择<span style="color: #6ca4f7">{{
        (isCheckAll || checkOrderIds.length || excludeOrderIds.length) && applyForm.orderCount ? applyForm.orderCount : 0
      }}</span>个订单，共计
      <span style="color: #6ca4f7">￥{{
          (isCheckAll || checkOrderIds.length || excludeOrderIds.length) && applyForm.totalAmount ? applyForm.totalAmount / 100 : 0
        }}</span>
    </div>

    <el-table :data="orders" style="width: 100%; margin-top: 20px; font-size: 12px">
      <el-table-column width="48">
        <template slot="header" slot-scope="scope">
          <el-checkbox v-model="isCheckAll" @change="checkAllOrder" :indeterminate="!!excludeOrderIds.length"/>
        </template>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.isCheck" @change="event => checkOneOrder(event, scope.row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="贵司订单号" prop="channelOrderNum" width="185"></el-table-column>
      <el-table-column label="科坦订单号" prop="outerId" width="185"></el-table-column>
      <el-table-column label="酒店名称" prop="hotelName"></el-table-column>
      <el-table-column label="开票类型" width="80">
        <template slot-scope="scope">
          {{ scope.row.invoiceType === 1 ? '普票' : '专票' }}
        </template>
      </el-table-column>
      <el-table-column label="订单金额" prop="payAmount" width="80">
        <template slot-scope="scope">
          {{ scope.row.payAmount ? `￥${scope.row.payAmount / 100}` : '' }}
        </template>
      </el-table-column>
      <el-table-column label="开票金额" prop="payAmount" width="80">
        <template slot-scope="scope">
          {{ scope.row.payAmount ? `￥${scope.row.payAmount / 100}` : '' }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="orderTime" width="145"></el-table-column>
      <el-table-column label="入离日期">
        <template slot-scope="scope">
          <div>{{ scope.row.checkIn }}</div>
          <div>{{ scope.row.checkOut }}</div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination :current-page="form.pageCurrent" :page-size="form.pageSize"
                     layout="total, prev, pager, next, jumper" :total="form.total" :hide-on-single-page="true"
                     @current-change="pageChange" style="margin: auto;">
      </el-pagination>
    </div>

    <el-dialog title="发票信息填写" :visible.sync="dialogVisible" width="750px" custom-class="my-dialog">
      <div class="dialog_box">
        <div style="padding: 10px;background-color: #f2f2f2;margin-bottom: 20px">
          <span style="color: #000000;font-weight: 600">发票开具总金额:</span>
          <span style="color: #4ba7fa">￥{{ this.applyForm.totalAmount / 100 }}</span>
        </div>
        <div style="display: flex;align-items: center;margin-bottom: 15px;">
          <div style="width: 110px;text-align: right;padding-right: 12px">发票抬头</div>
          <el-select v-model="invoiceBasicId" placeholder="请选择" size="mini" style="width: 600px" clearable
                     @change="checkInvoice">
            <el-option v-for="item in invoices" :key="item.invoiceBaiscId" :value="item.invoiceBaiscId"
                       :label="item.invoiceTitle"/>
          </el-select>
        </div>
        <InvoiceEdit ref="invoiceRef"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="applyInvoice">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import InvoiceEdit from './components/InvoiceEdit.vue'

export default {
  name: 'InvoiceManage',
  components: {InvoiceEdit},
  data () {
    return {
      partnerInfo: {},
      headers: {},
      form: {
        dateType: 0,
        pageSize: 10,
        pageCurrent: 1,
        total: 0
      },
      orders: [],
      isCheckAll: false,
      checkOrderIds: [],
      excludeOrderIds: [],
      dialogVisible: false,
      applyForm: {},
      invoiceBasicId: '',
      invoices: [],
      height: 0
    }
  },
  created () {
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    this.headers = {accessToken: this.partnerInfo.token}
    if (!this.partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    }
    this.height = this.$common.getScreenInfo().height - 90 - 40
    this.onSearch(true)
  },
  methods: {
    pageChange (e) {
      this.form.pageCurrent = e
      this.onSearch()
    },
    async onSearch (type) {
      if (type) {
        this.isCheckAll = false
        this.checkOrderIds = []
        this.excludeOrderIds = []
        this.form.pageCurrent = 1
      }
      const {data: result} = await this.$http.post('/b2b/searchInvoiceOrders', this.form, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.orders = result.data.data
      this.orders.forEach(item => {
        this.$set(item, 'isCheck', (this.isCheckAll && !this.excludeOrderIds.includes(item.orderId)) || this.checkOrderIds.includes(item.orderId))
      })
      this.form.total = result.data.total
    },
    checkOneOrder (e, row) {
      if (e) {
        if (!this.checkOrderIds.includes(row.orderId)) {
          this.checkOrderIds.push(row.orderId)
          if (this.isCheckAll) {
            this.excludeOrderIds = this.excludeOrderIds.filter(item => item !== row.orderId)
          }
        }
      } else {
        this.checkOrderIds = this.checkOrderIds.filter(item => item !== row.orderId)
        if (this.isCheckAll) {
          this.excludeOrderIds.push(row.orderId)
        }
      }
      this.getInvoiceAmountInfo()
    },
    checkAllOrder (e) {
      this.checkOrderIds = []
      this.excludeOrderIds = []
      this.orders.forEach(item => {
        this.$set(item, 'isCheck', e)
      })
      this.getInvoiceAmountInfo()
    },
    async getInvoiceAmountInfo () {
      if (!this.isCheckAll && !this.checkOrderIds.length && !this.excludeOrderIds.length) return
      let req = {...this.form}
      req.selectAll = this.isCheckAll
      req.excludeOrderIds = this.excludeOrderIds
      req.orderIds = this.checkOrderIds
      const {data: result} = await this.$http.post('/b2b/getB2BInvoiceAmountInfo', req, {headers: this.headers})
      if (result.code !== 200) {
        this.isCheckAll = false
        this.checkOrderIds = []
        this.excludeOrderIds = []
        this.orders.forEach(item => {
          this.$set(item, 'isCheck', false)
        })
        return this.$message.error(result.message)
      }
      this.applyForm = result.data
    },
    async toApplyInvoice () {
      if (!this.orders.length) return this.$message.warning('请选择需要开票的订单')
      if (!this.isCheckAll && !this.checkOrderIds.length && !this.excludeOrderIds.length) return this.$message.warning('请选择需要开票的订单')
      let req = {...this.form}
      req.selectAll = this.isCheckAll
      req.excludeOrderIds = this.excludeOrderIds
      req.orderIds = this.checkOrderIds
      const {data: result} = await this.$http.post('/b2b/getB2BInvoiceAmountInfo', req, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.applyForm = result.data
      this.invoiceBasicId = ''
      await this.getB2BInvoiceBasicInfos()
      this.dialogVisible = true
      this.$nextTick(() => {
        let invoiceType = result.data.invoiceType === 1 ? '增值税电子普通发票' : '增值税电子专用发票'
        this.$refs['invoiceRef'].init(invoiceType)
      })
    },
    async getB2BInvoiceBasicInfos () {
      const {data: result} = await this.$http.get('/b2b/getB2BInvoiceBasicInfos', {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.invoices = result.data
    },
    checkInvoice (e) {
      let invoice = this.invoices.find(item => item.invoiceBaiscId === e)
      let invoiceType = this.applyForm.invoiceType === 1 ? '增值税电子普通发票' : '增值税电子专用发票'
      this.$refs['invoiceRef'].init(invoiceType, invoice)
    },
    async applyInvoice () {
      const invoiceInfo = this.$refs['invoiceRef'].invoice
      let errMsg = this.checkForm(invoiceInfo)
      if (errMsg) return this.$message.warning(errMsg)
      let req = {
        invoiceInfo: {...invoiceInfo, invoiceBaiscId: invoiceInfo.invoiceBaiscId ? invoiceInfo.invoiceBaiscId : 0},
        ...this.applyForm,
        invoiceContent: invoiceInfo.invoiceContent
      }
      const {data: result} = await this.$http.post('/b2b/applyB2BInvoice', req, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.dialogVisible = false
      let url = `/invoiceDetail?id=${result.data}`
      window.open(url, '_blank')
    },
    checkForm (form) {
      if (!form.invoiceTitle) return '请输入公司名称(发票抬头)'
      if (!form.taxIdentifyNumber) return '请输入公司税号'
      if (!this.checkTaxpayerId(form.taxIdentifyNumber)) return '请输入正确的税号'
      if (!(form.companyAddress && form.companyPhone && form.accountBankName && form.accountBankid ||
        (!form.companyAddress && !form.companyPhone && !form.accountBankName && !form.accountBankid))) {
        return '开增值税发票需提完整的信息'
      }
      if (!form.checkTakerPhone) return '请输入收票人手机'
      if (!form.checkTakerEmail) return '请输入收票人邮箱'
    },
    checkTaxpayerId (taxpayerId) {
      if (!taxpayerId || taxpayerId.length !== 18) {
        return false
      }
      return /^[A-Z0-9]+$/.test(taxpayerId)
    }
  }
}
</script>

<style scoped lang="less">
.max_box {
  background-color: #fff;
  padding: 20px;
}

.box_form {
  padding: 20px;
  border: 1px solid #e7e7e7;
  background-color: #f7f7f7;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 15px;
  align-items: center;

  .time_box {
    display: grid;
    grid-template-columns: repeat(3, max-content);
    align-items: center;
    grid-column-gap: 10px;
  }

  & /deep/ .el-input .el-select {
    min-width: auto !important;
    width: auto !important;
  }
}

.pagination {
  margin: 35px;
  position: relative;

  /deep/ .el-pagination {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

/deep/ .el-table th,
.el-table tr {
  background-color: #f7f7f7;
}

.dialog_box {
  border-top: 1px solid #eaeaea;
  padding-top: 10px;
}

/deep/ .el-dialog__header {
  background-color: #fff;
  padding: 10px 20px;
}

/deep/ .el-dialog__title {
  color: #000;
  font-size: 16px;
  font-weight: 500;
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
}

/deep/ .el-dialog.my-dialog {
  position: relative;
  left: 30%;
  top: 0;
  margin-top: 30px !important;
  transform: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/InvoiceManage.vue